import React, { useContext, useEffect, useState, ReactNode } from 'react';
import AuthContext from '../../store/AuthContext';
import { isJwtExpired } from '../../utils/jwtExpiry';
interface AuthCheckerProps {
  children: ReactNode;
}

const AuthChecker: React.FC<AuthCheckerProps> = ({ children }) => {
  const { setIsAuthenticated } = useContext(AuthContext);
  const [checkingAuth, setCheckingAuth] = useState(true);

  const getCookie = (name: string) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  };

  useEffect(() => {
    const token = sessionStorage.getItem('token') || getCookie('token');
    let decoded: { exp?: number } | null = null;
    try {
      const raw = sessionStorage.getItem('token_decoded') || getCookie('token_decoded');
      if (raw) {
        decoded = JSON.parse(raw);
      }
    } catch {
      decoded = null;
    }

    if (token && decoded && !isJwtExpired(decoded)) {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }

    setCheckingAuth(false);
  }, [setIsAuthenticated]);

  if (checkingAuth) {
    return <div>Cargando...</div>;
  }

  return <>{children}</>;
};

export default AuthChecker;
